import { useState, useCallback, useEffect } from 'react';

import SlideToggle from './components/SlideToggle';

const path = document.querySelector<HTMLBodyElement>('body').dataset.path;

const debounce = (func, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), delay);
  };
};

type Menu = {
  id: 'job' | 'sector' | 'system' | 'internship'| 'session' | 'benefit' | 'volunteer',
  title: string,
  link?: string,
  target?: string,
  list?: {
    text: string,
    link?: string,
    direct?: boolean,
    target?: string,
  }[][],
}[];

const menu: Menu = [

   {
    id: 'about',
    title: '看護部について',
    link: '/about.html',
  },
  {
    id: 'department',
    title: '部門紹介',
    list: [
      [
        {
          text: '病棟',
          link: '/department/ward.html',
        },
        {
          text: '救急関係',
          link: '/department/emergency.html',
        },
        {
          text: '手術室・消化器センター',
          link: '/department/or.html',
        },
        {
          text: '外来・在宅・専門部門',
          link: '/department/outpatient.html',
        },
      ],
    ],
  },
  {
    id: 'support',
    title: 'サポート体制',
    list: [
      [
        {
          text: '教育体制',
          link: '/support/education.html',
        },
        {
          text: '福利厚生',
          link: '/support/welfare.html',
        },
      ],
    ],
  },
  {
    id: 'message',
    title: '看護師の声',
    link: '/voice.html',
  },
  {
    id: 'specialist',
    title: '専門・認定看護師',
    list: [
      [
        {
          text: '専門・認定看護師',
          link: '/specialist/index.html',
        },
        {
          text: '専門・認定看護師からのメッセージ',
          link: '/specialist/messege.html',
        },
        {
          text: '専門・認定看護師の活動',
          link: '/specialist/activitylist.html',
        },
        {
          text: '看護部学会について',
          link: "https://www.minamitohoku.or.jp/about/academic/lecture.html?ctgr=12",
          target: '_blank',
        },
      ],
    ],
  },
  {
    id: 'entry',
    title: '採用情報',
    list: [
      [
        {
          text: '応募要項',
          link: 'https://www.minamitohoku.or.jp/recruit/jobs/list.html?ctgl2=3',
          target: '_blank',
        },
        {
          text: '説明会',
          link: 'https://www.minamitohoku.or.jp/recruit/session/',
          target: '_blank',
        },
        {
          text: 'インターンシップ',
          link: 'https://www.minamitohoku.or.jp/recruit/internship/',
          target: '_blank',
        },
      ],
    ],
  },
];

export default function KangoHeaderNav() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [open, setOpen] = useState(false);
  const [sub, setSub] = useState('');

  const handleOpen = () => {
    setOpen((prev) => !prev);
    setSub('');
  };

  const handleSub: React.MouseEventHandler<HTMLButtonElement> = useCallback((event) => {
    const target = event.currentTarget;
    const value = target.value;

    setSub((prev) => {
      return prev === value ? '' : value;
    });
  }, []);

  const handleSubClose: React.MouseEventHandler<HTMLAnchorElement> = useCallback((event) => {
    setOpen(false);
    setSub('');
  }, []);

  const focusTrap = document.getElementById('js-focusTrap');
  focusTrap.addEventListener('focus', (e) => {
    setOpen(false);
    setSub('');
  });

  window.addEventListener('keydown', () => {
    if (event.key === 'Escape') {
      setOpen(false);
      setSub('');
    }
  });

  useEffect(() => {
    if(open && windowSize.width <= 1080) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = null;
    }
  }, [open]);

  useEffect(() => {
    const handleResize = debounce(() => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }, 300);

    window.addEventListener('resize', handleResize);

    if(windowSize.width >= 1080) {
      setOpen(false);
      setSub('');
    }

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [windowSize]);

  return (
    <>
      <button id='js-navToggle' className={'headerToggle'} onClick={handleOpen} type='button' aria-expanded={open} aria-controls='js-globalNav' aria-label={open ? '総合メニューを閉じます' : '総合メニューを開きます'}>
        <span className={'headerToggleLine'} />
        <span className={'headerToggleLine'} />
        <span className={'headerToggleText'}>メニュー</span>
      </button>


      <div className={open ? 'globalNavWrap -active' : 'globalNavWrap'}>

        <div className={'globalSubNav globalSubNavPC'}>
          <ul className={'globalSubNavList recruitSubNavList'}>
            <li className={'globalSubNavListItem'}>
              <a className={'globalSubNavLink'} href={`tel:024-934-5604`}>TEL：024-934-5604</a>
            </li>
            <li className={'globalSubNavListItem'}>
              <a className={'kangoNavContactLink'} href={`${path}recruit/inquiry/index.html?kind=2`}  target="_blank" rel="noopener noreferrer">
                <span className={'mailBtn__icon'}>
                  <img src={`${path}/images/icon_mail_white.svg`} alt=''/>
                  <img src={`${path}/images/icon_mail_blue.svg`} alt=''/>
                </span>
                <span className={'kangoNavContactLinkText'}>お問合せ・見学</span>
              </a>
            </li>
            <li className={'globalSubNavListItem'}>
              <a className={'kangoNavTopLink'} href={`${path}`}>総合南東北病院TOP</a>
            </li>
          </ul>
        </div>

        <nav className={'globalNav'}>
          <ul className={'globalNavList recruitNavList'}>
            {
              menu.map(({ id, title, link, list, target }) => {
                return (
                  <li className={'globalNavListItem'} key={id}>
                    {
                      link ? (
                        <a className={'globalNavToggle'} href={link?.startsWith('http') ? link : `${path}${link}`}target={target} rel={target ? 'noreferrer' : ''}>{title}</a>
                      ) : (
                        <>
                          <button
                            className={list ? 'globalNavToggle hasArrow' : 'globalNavToggle'}
                            type='button'
                            value={id}
                            onClick={handleSub}
                            aria-controls={'js-nav-' + id}
                            aria-expanded={sub === id}
                            aria-label={sub === id ? title + 'メニューを閉じます' : title + 'メニューを開きます'}
                          >
                            {title}
                          
                          <SlideToggle id={id} open={sub === id}>
                            <div className={'globalNavAccordion'}>
                              {
                                list.map((box, index) => {
                                  return (
                                    <ul className={'globalNavChildList'} key={index}>
                                      {
                                        box.map((item) => {
                                          return (
                                            <li className={'globalNavChildListItem'} key={item.text}>
                                              <a 
                                              className={'globalNavChildLink'}
                                               href={item.link?.startsWith('http')? item.link: `${path}${item.link}`} 
                                               target={item.target}
                                               rel={item.target ? 'noopener noreferrer' : undefined}
                                               onClick={handleSubClose}
                                               >
                                                {item.text}
                                                </a>
                                            </li>
                                          );
                                        })
                                      }
                                    </ul>
                                  );
                                })
                              }
                            </div>
                          </SlideToggle>
                          </button>
                        </>
                      )
                    }
                  </li>
                );
              })
            }
          </ul>
        </nav>

        <div className={'globalSubNav globalSubNavSP'}>
          <ul className={'globalSubNavList recruitSubNavList'}>
            <li className={'globalSubNavListItem'}>
              <a className={'globalSubNavLink'} href={`tel:024-934-5604`}>TEL：024-934-5604</a>
            </li>
            <li className={'globalSubNavListItem'}>
              <a className={'kangoNavContactLink'} href={`${path}recruit/inquiry/index.html?kind=2`}  target="_blank" rel="noopener noreferrer">
                <span className={'mailBtn__icon'}>
                  <img src={`${path}/images/icon_mail_white.svg`} alt=''/>
                  <img src={`${path}/images/icon_mail_blue.svg`} alt=''/>
                </span>
                <span className={'kangoNavContactLinkText'}>お問合せ・見学</span>
              </a>
            </li>
            <li className={'globalSubNavListItem'}>
              <a className={'kangoNavTopLink'} href={`${path}`}>総合南東北病院TOP</a>
            </li>
          </ul>

          <div className={'globalSubNavSPContents'}>
            <div className={'copyright'}>©2026 Southern TOHOKU Research Institute for Neuroscience.</div>
          </div>
        </div>

      </div>
    </>
  );
}